<template>
    <div id="tablePrint">
       <b-table
            show-empty
            responsive
            :items="reportReceipt.listReportReceipt"
            :fields="fields"
            :per-page="search.perPage"
            :busy="search.isLoading"
            class="scroll-bar-pop text-center"
            empty-text="ไม่มีรายการออกใบเสร็จ"
            empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
            foot-clone
        >
            <div slot="HEAD_total_net_price" slot-scope="row">
                {{row.label}}
                <i
                    class="fas fa-info-circle fa-xs text-primary cursor-pointer"
                    v-b-tooltip
                    title='นิติบุคคลหักภาษี ณ ที่จ่าย จากค่าขนส่ง 1% และค่าบริการ 3%'>
                </i>
            </div>
            <div slot="table-busy" class="text-center">
                <div class="text-center text-primary my-2">
                    <i class="fas fa-circle-notch fa-spin"></i>
                    <strong> Loading...</strong>
                </div>
            </div>
            <template slot="index" slot-scope="data">
                {{ getOverAllIndex(data.index) }}
            </template>
            <template slot="paid_at" slot-scope="row">
                {{ row.item.paid_at | dateFormat }}
            </template>
            <template slot="invoice_shop_name" slot-scope="row">
                {{ row.item.invoice_shop_name }}
            </template>
            <template slot="period" slot-scope="row">
                  {{ row.item.period }}
            </template>
            <template slot="receipt_no" slot-scope="row">
                <a
                    v-if="
                        'invoice_document_no' in row.item
                        && row.item.invoice_document_no
                        && 'invoice_eaccount_cb' in row.item
                        && row.item.invoice_eaccount_cb === 'READY'
                    "
                    class="a-tag color-tag"
                    @click="getEAccountDocument(row.item.id)"
                >
                    {{ row.item.invoice_document_no }}
                </a>
                <a
                    v-else
                    class="a-tag color-tag"
                >
                    <span class="unclickable-text">
                        {{ row.item.invoice_document_no }}
                    </span>
                </a>
            </template>
            <template slot="total_courier_cost" slot-scope="row">
                {{ row.item.total_courier_cost | numFormat('0,0.00') }}
            </template>
            <template slot="total_insurance" slot-scope="row">
                {{ row.item.total_insurance | numFormat('0,0.00') }}
            </template>
            <template slot="total_additional_fuel_charge" slot-scope="row">
                {{ row.item.total_additional_fuel_charge | numFormat('0,0.00') }}
            </template>
            <template slot="total_service" slot-scope="row">
                {{ row.item.total_service | numFormat('0,0.00') }}
            </template>
            <template slot="vat_price" slot-scope="row">
                {{ row.item.vat_price | numFormat('0,0.00') }}
            </template>
            <template slot="total_service_exclude_vat" slot-scope="row">
                {{ row.item.total_service_exclude_vat | numFormat('0,0.00') }}
            </template>
            <template slot="freight_discount" slot-scope="row">
                {{ row.item.freight_discount | numFormat('0,0.00') }}
            </template>
            <template slot="service_discount" slot-scope="row">
                {{ row.item.service_discount | numFormat('0,0.00') }}
            </template>
            <template slot="total" slot-scope="row">
                {{ row.item.total | numFormat('0,0.00') }}
            </template>
            <template slot="total_courier_cost_wht" slot-scope="row">
                {{ row.item.total_courier_cost_wht | numFormat('0,0.00') }}
            </template>
            <template slot="total_service_exclude_vat_wht" slot-scope="row">
                {{ row.item.total_service_exclude_vat_wht | numFormat('0,0.00') }}
            </template>
            <template slot="total_net_price" slot-scope="row">
                {{ row.item.total_net_price | numFormat('0,0.00') }}
            </template>
            <template slot="manage" slot-scope="row">
                <b-button variant="primary" size="sm" @click="downloadOrderSummaryFile(row.item.id)" :disabled="!row.item.location">
                    <span class="px-2">
                        <Icon icon="mdi-tray-arrow-up" /> รายการทั้งหมด
                    </span>
                </b-button>
            </template>

            <template slot="FOOT_index">&nbsp;</template>
            <template slot="FOOT_paid_at">&nbsp;</template>
            <template slot="FOOT_receipt_no">&nbsp;</template>
            <template slot="FOOT_total_courier_cost">{{reportReceipt.listTotalReceipt.courier_cost | numFormat('0,0.00') }}</template>
            <template slot="FOOT_total_insurance">{{reportReceipt.listReportReceipt.insurance | numFormat('0,0.00') }}</template>
            <template slot="FOOT_total_additional_fuel_charge">{{reportReceipt.listTotalReceipt.additional_fuel_charge | numFormat('0,0.00') }}</template>
            <template slot="FOOT_total_service">{{reportReceipt.listTotalReceipt.service | numFormat('0,0.00') }}</template>
            <template slot="FOOT_vat_price">{{reportReceipt.listTotalReceipt.vat_price | numFormat('0,0.00') }}</template>
            <template slot="FOOT_total_service_exclude_vat">{{reportReceipt.listTotalReceipt.service_exclude_vat | numFormat('0,0.00') }}</template>
            <template slot="FOOT_freight_discount">{{reportReceipt.listTotalReceipt.freight_discount | numFormat('0,0.00') }}</template>
            <template slot="FOOT_service_discount">{{reportReceipt.listTotalReceipt.service_discount | numFormat('0,0.00') }}</template>
            <template slot="FOOT_total">{{ reportReceipt.listTotalReceipt.total | numFormat('0,0.00') }}</template>
            <template slot="FOOT_total_courier_cost_wht">{{reportReceipt.listTotalReceipt.courier_cost_wht | numFormat('0,0.00') }}</template>
            <template slot="FOOT_total_service_exclude_vat_wht">{{reportReceipt.listTotalReceipt.service_exclude_vat_wht | numFormat('0,0.00') }}</template>
            <template slot="FOOT_total_net_wht">{{reportReceipt.listTotalReceipt.net_wht | numFormat('0,0.00') }}</template>
            <template slot="FOOT_total_net_price">{{reportReceipt.listTotalReceipt.net_price | numFormat('0,0.00') }}</template>
            <template slot="FOOT_manage">&nbsp;</template>
       </b-table>
       <div class="mt-3">
        <b-pagination
            :total-rows="search.totalItem"
            :current-page="search.page"
            :per-page="search.perPage"
            :value="search.page"
            @input="changePage"
            align="right"
        ></b-pagination>
       </div>
    </div>
</template>

<script>
import moment from 'moment'
import { fieldExport, fieldShopExport } from '@/components/custom/reportReceipt/fieldExcelReceipt'
import { getEAccountDocumentDownloadUrl } from '@/axios/receipt'
import { getOrderSummaryDownloadURL } from '@/axios/invoice'
import { showErrorModal } from "@/components/modalNotification";

export default {
    props: {
        search: Object,
        reportReceipt: Object,
        type: String
    },
    data() {
        return {
        }
    },
    filters: {
        dateFormat(date) {
            return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm:ss");
        },
    },
    methods: {
        getOverAllIndex(index){
            return (this.search.page * 25) - 25 + index + 1
        },
        changePage(i) {
            if (this.search.page == i) return

            this.search.page = i
            this.$emit('getReport')
        },
        getEAccountDocument(id) {
            this.reportReceipt.busy = true

            getEAccountDocumentDownloadUrl(id).then((res) => {
                const url = res.download_url

                if (url){
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('target', '_blank')
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                }else{
                    showErrorModal('ไม่มีข้อมูล')
                }
            }).catch((err) => {
                // eslint-disable-next-line no-console
                console.log(err)
                showErrorModal(err)
            }).finally(() => {
                this.reportReceipt.busy = false
            })
        },
        downloadOrderSummaryFile(id) {
            this.reportReceipt.busy = true

            getOrderSummaryDownloadURL(id).then((res) => {
                const url = res.download_url

                if (url){
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('target', '_blank')
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                }else{
                    showErrorModal('ไม่มีข้อมูล')
                }
            }).catch((err) => {
                // eslint-disable-next-line no-console
                console.log(err)
                showErrorModal(err)
            }).finally(() => {
                this.reportReceipt.busy = false
            })
        }
    },
    computed:{
        fields(){
            if (this.main_use_walletV2) {
                return fieldShopExport[this.type];
            }

            return fieldExport[this.type];
        }
    }
}
</script>

<style>
.unclickable-text {
  color: #888;
  pointer-events: none;
}
</style>
